var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 3.8C0.25 1.83939 1.83939 0.25 3.8 0.25H14.2C16.1606 0.25 17.75 1.83939 17.75 3.8V10.2C17.75 12.1606 16.1606 13.75 14.2 13.75H3.8C1.83939 13.75 0.25 12.1606 0.25 10.2V3.8ZM3.8 1.75C2.66782 1.75 1.75 2.66782 1.75 3.8V10.2C1.75 11.3322 2.66782 12.25 3.8 12.25H14.2C15.3322 12.25 16.25 11.3322 16.25 10.2V3.8C16.25 2.66782 15.3322 1.75 14.2 1.75H3.8Z",
    fill: "#2C2C2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40004 4.55C4.64857 4.21863 5.11867 4.15147 5.45004 4.4L8.85004 6.95C8.93893 7.01666 9.06116 7.01666 9.15004 6.95L12.55 4.4C12.8814 4.15147 13.3515 4.21863 13.6 4.55C13.8486 4.88137 13.7814 5.35147 13.45 5.6L10.05 8.15C9.42782 8.61666 8.57227 8.61666 7.95004 8.15L4.55004 5.6C4.21867 5.35147 4.15152 4.88137 4.40004 4.55Z",
    fill: "#2C2C2C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.133c1a45773b4d811673de9bd33b3500.svg";
export { ForwardRef as ReactComponent };